import * as React from 'react';

class PointerLeftSmallSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 12 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon pointer-left-small-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M1.48998 6.74001C3.87138 4.22118 6.55898 2.01063 9.48998 0.160011C9.71409 0.0181204 9.98539 -0.0289329 10.2442 0.0292034C10.503 0.0873396 10.7281 0.245903 10.87 0.470011C11.0119 0.694119 11.0589 0.965414 11.0008 1.22421C10.9427 1.48301 10.7841 1.70812 10.56 1.85001C7.82017 3.58455 5.30454 5.65012 3.06998 8.00001C5.29209 10.3571 7.79787 12.4296 10.53 14.17C10.641 14.2403 10.737 14.3317 10.8126 14.4391C10.8883 14.5464 10.942 14.6677 10.9708 14.7958C10.9996 14.924 11.0028 15.0565 10.9804 15.1859C10.958 15.3153 10.9102 15.439 10.84 15.55C10.7697 15.661 10.6783 15.757 10.5709 15.8327C10.4636 15.9083 10.3423 15.962 10.2142 15.9908C10.086 16.0196 9.95348 16.0229 9.82408 16.0004C9.69467 15.978 9.57095 15.9303 9.45998 15.86C6.52536 13.9988 3.83745 11.7745 1.45998 9.24001C1.14361 8.90266 0.967529 8.45751 0.967529 7.99501C0.967529 7.53252 1.14361 7.08737 1.45998 6.75001L1.48998 6.74001Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default PointerLeftSmallSvg;
